<template>
  <footer id="footer" role="contentinfo">
<p>Executive Advantage Planner &nbsp; &copy; {{getYear}}.</p>
</footer>
</template>
<script>
export default {

  computed: {
    getYear(){
      return  new Date().getFullYear();
    }
  }
  
}
</script>